import React from "react";
//Material imports
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles"; //Limitless imports

import { withi18n } from "../../hocs/i18n";

var RateYourExperienceFooter = function RateYourExperienceFooter(_ref) {
  var onClick = _ref.onClick,
      classes = _ref.classes,
      t = _ref.t;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.experienceContainer
  }, /*#__PURE__*/React.createElement(Button, {
    className: classes.rateExperienceBtn,
    color: "primary",
    onClick: onClick
  }, t("Rate your experience")));
};

var styles = function styles() {
  return {
    experienceContainer: {
      display: "flex",
      flex: "1",
      justifyContent: "center",
      alignItems: "center",
      borderTop: "2px solid rgba(0, 0, 0, 0.06)"
    },
    rateExperienceBtn: {
      height: 44
    }
  };
};

export default withStyles(styles)(withi18n(RateYourExperienceFooter));